module.exports = __webpack_public_path__ + "img/front_of_group3.9244440b.jpg";